<style scoped>

</style>

<template>
  <mu-card>
    <quiz-panel
      :mediaId="mediaId"
      :currentTime="currentTime"
      />
  </mu-card>
</template>

<script>

// Components
import QuizPanel from '@/components/Quiz/QuizPanel.vue'

export default {
  name: 'QuestionTab',
  components: {
    QuizPanel
  },
  props: {
    mediaId: {
      type: String,
      required: true
    },
    currentTime: {
      type: Number,
      required: true
    },
  },
}
</script>
